import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_checked",
  "use": "icon-icon_checked-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"icon-icon_checked\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h36v36H0z\" /><path fill=\"#E84C3D\" d=\"m15 22.758 13.788-13.79 2.122 2.121L15 27l-9.546-9.546 2.121-2.121z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol